import React, { Component } from 'react';
import classnames from 'classnames';
import { Clock } from 'components/icons/Clock';
import { connect } from 'react-redux';
import Helmet from 'react-helmet';
import Styles from 'views/pages/CursosOnline.module.scss';

class Curso extends Component {
  constructor(props) {
    super(props);

    this.state = {
      current: 0,
      currentQuestion: 0,
      openMobileList: props.ui.mobile ? true : false,
      showMobileContent: props.ui.mobile ? false : true,
      courseContent: null,
    };

    this.categories = this.categories.bind(this);
    this.listMobileActive = this.listMobileActive.bind(this);
    this.listMobileClose = this.listMobileClose.bind(this);
  }

  categories(k) {
    this.setState({
      current: k,
      currentQuestion: 0,
    });
    console.log(this.state.current);
  }

  subCategory(k) {
    return () => {
      this.setState({
        currentQuestion: k,
        openMobileList: false,
        showMobileContent: true,
      });
    };
  }

  listMobileActive() {
    return () => {
      this.setState({ openMobileList: true, showMobileContent: false });
    };
  }

  listMobileClose() {
    return () => {
      this.setState({ openMobileList: false, showMobileContent: true });
    };
  }

  componentDidMount() {
    const { person, history } = this.props;

    let { slug, key } = this.props.match.params;
    let courseData = require(`../../assets/data/cursos/data/${slug}.json`);

    this.setState({
      courseContent: courseData.courses[key],
    });
  }

  renderCourseDescription = () => {
    let { courseContent } = this.state;
    if (!courseContent) return null;

    let author = !courseContent.author ? (
      <small> {courseContent.author}</small>
    ) : (
      <small>by {courseContent.author}</small>
    );

    let weburnText =
      courseContent.name === 'Yoga' || courseContent.name === 'Receita Natureba' ? (
        <p>
          <a target="_blank" href={'https://bit.ly/glambox-wb'}>
            E, se quiser testar outras modalidades como hit, dança e muito mais, a Weburn oferece
            para você Glamgirl uma assinatura por apenas R$9,90, aproveite!
          </a>
        </p>
      ) : null;

    return (
      <div>
        <header>
          <div
            className={classnames('btn btn-sm btn-light-pink', Styles['back-courses'])}
            onClick={() => this.backCToCourses()}
          >
            <i className="fas fa-angle-left"></i>
            <span>Voltar aos cursos</span>
          </div>

          <h1>{courseContent.name}</h1>
          {author}
          <p dangerouslySetInnerHTML={{ __html: courseContent.description }} />

          {weburnText}
        </header>
      </div>
    );
  };

  backCToCourses = () => {
    let { slug } = this.props.match.params;

    this.props.history.push('/cursos-online/' + slug);
  };

  renderCoursePreviews = () => {
    let { courseContent, current } = this.state;
    if (!courseContent || current == -1) return null;

    return courseContent.modules.map((module, subkey) => {
      let saibaMais =
        module.link != null ? (
          <>
            <br />
            <br />
            <a href={module.link} target={'_blank'} className={'linkAnchor'}>
              Saiba mais
            </a>
          </>
        ) : null;
      let moduleDescription =
        module.description != null ? (
          <p className={'desc'}>
            {module.description}
            {saibaMais}
          </p>
        ) : null;

      return (
        <div key={subkey}>
          <button
            className={subkey === this.state.current ? 'isActive' : ''}
            onClick={(e) => this.categories(subkey)}
          >
            <span className={'arrow'}>&#8250;</span> {module.name}{' '}
            <span className={'quantity'}>0/{module.content.length}</span>
          </button>
          <div className={'toogle ' + (subkey === this.state.current ? 'isActive' : '')}>
            {moduleDescription}
            <ul>
              {module.content.map((video, subkey1) => (
                <li key={subkey1}>
                  <button
                    className={
                      subkey1 === this.state.currentQuestion && subkey === this.state.current
                        ? 'isActive'
                        : ''
                    }
                    onClick={this.subCategory(subkey1)}
                  >
                    {video.title}
                  </button>
                </li>
              ))}
            </ul>
          </div>
        </div>
      );
    });
  };

  renderCourseVideos = () => {
    let { courseContent, current } = this.state;
    if (!courseContent || current === -1) return null;

    return (
      <>
        <div id="video-view">
          <div className="video-wrap">
            <div className="video-container">
              <iframe
                width={'640'}
                height={'360'}
                frameBorder={'0'}
                allow={'autoplay; fullscreen'}
                allowFullScreen={''}
                src={
                  'https://player.vimeo.com/video/' +
                  courseContent.modules[this.state.current].content[this.state.currentQuestion]
                    .code +
                  '?quality=540p'
                }
              ></iframe>
            </div>
          </div>
        </div>
        <div className={'level-2 video-detail'}>
          <h2>
            {courseContent.modules[this.state.current].content[this.state.currentQuestion].title}
          </h2>
          <p
            dangerouslySetInnerHTML={{
              __html:
                courseContent.modules[this.state.current].content[this.state.currentQuestion]
                  .description,
            }}
          />
        </div>
      </>
    );
  };

  render() {
    const { match } = this.props;
    let activeTab = match.params.hasOwnProperty('tab') ? match.params.tab : null;

    return (
      <div className={'wrapCurso'}>
        <Helmet>
          <title>Minha Glambox : Curso Online</title>
        </Helmet>

        <div
          className={classnames(
            'listCourse',
            this.state.showMobileContent === false ? 'isActive' : ''
          )}
        >
          <button className={'closeList'} onClick={this.listMobileClose()}>
            x
          </button>
          {this.renderCourseDescription()}

          {this.renderCoursePreviews()}
        </div>
        <div
          className={classnames(
            'courseContent',
            this.state.openMobileList === true ? 'notVisible' : ''
          )}
        >
          {/* "gbBt small flat default" */}
          <button className={'btn btn-light-pink btn-sm'} onClick={this.listMobileActive()}>
            Assistir outro video
          </button>
          {this.renderCourseVideos()}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  person: state.person,
  ui: state.ui,
});

const mapDispatchToProps = (dispatch) => ({});

Curso = connect(mapStateToProps, mapDispatchToProps)(Curso);

export { Curso };
